<template lang="pug">
v-footer#footer-section(color="grey darken-4")
  v-container.white--text.pa-4.pa-sm-12(style="max-width: 1366px")
    v-row.my-lg-12.justify-start.justify-md-center(align="start")
      v-col(cols="auto")
        v-row
          v-col(cols="auto")
            v-img.mb-4(
              src="../assets/logo-white.svg"
              position="left center"
              contain
              eager
              height=32
            )
        v-row
          v-col(cols="auto")
            a#contact-btn.ibm.text-subtitle-2.text-sm-h6.box-anchor(
              @click="$router.push('/')"
            ) para você
          v-col(cols="auto")
            a#contact-btn.ibm.text-subtitle-2.text-sm-h6.box-anchor(
              @click="$goTo({ path: '/empresa' })"
            ) para empresas
          v-col(cols="auto")
            a#contact-btn.ibm.text-subtitle-2.text-sm-h6.box-anchor(
              @click="$goTo({ path: '/planos' })"
            ) planos
          v-col(cols="auto")
            a#contact-btn.ibm.text-subtitle-2.text-sm-h6.box-anchor(
              @click="$goTo({ path: '/contato' })"
            ) contato
          v-col(cols="auto")
            a#contact-btn.ibm.text-subtitle-2.text-sm-h6.box-anchor entrar
      v-divider.white.mx-14(v-if="$vuetify.breakpoint.lgAndUp" vertical inset)
      //- div.spacer-line.mx-12(v-if='$vuetify.breakpoint.lgAndUp')
      v-col(cols="auto")
        v-row(
          align="center"
          :justify="$vuetify.breakpoint.xsOnly ? 'start' : 'center'"
        )
          v-col.mt-10.mt-md-0.ml-md-8(cols="auto")
            v-img.mb-4(
              src="../assets/beyond-logo-white.svg"
              contain
              eager
              width=128
            )
            //- div.beyond-info Rua General Polidoro, 714 - Sala 103/105
            //- div.beyond-info Várzea, Recife/PE - CEP 50740-050
            //- div.beyond-info CNPJ 32.465.035/0001-92
            .text--grey.text--lighten-4.text-body-2 +55 81 3204-7240
            .text--grey.text--lighten-4.text-body-2 contato@beyondcompany.com.br
            .text--grey.text--lighten-4.text-body-2 beyondcompany.com.br
            .mt-6
              v-btn(icon dark large aria-label="Facebook page")
                v-icon mdi-facebook
              v-btn(
                icon
                dark
                large
                aria-label="Instagram page"
                @click="openUrl('https://www.instagram.com/co_beyond/')"
              )
                v-icon mdi-instagram
              v-btn(
                icon
                dark
                large
                aria-label="Linkedin page"
                @click="openUrl('https://www.linkedin.com/company/beyond-cloud/')"
              )
                v-icon mdi-linkedin
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      produtos: [
        {
          title: 'minha sala',
          link: 'https://www.minhasala.app'
        },
        {
          title: 'quoti',
          link: 'https://www.quoti.com.br'
        },
        {
          title: 'jusapi',
          link: 'https://www.jusapi.com'
        }
      ],
      servicos: [
        {
          title: 'design',
          link: '#'
        },
        {
          title: 'consultoria',
          link: '#'
        },
        {
          title: 'desenvolvimento',
          link: '#'
        }
      ],
      beyondcompany: [
        {
          title: 'sobre',
          link: '#'
        },
        {
          title: 'nosso time',
          link: '#'
        },
        {
          title: 'parceiros',
          link: '#'
        }
      ]
    }
  },
  methods: {
    openUrl(url) {
      window.open(url, '_blank')
    },
    goToContact() {
      this.$router.push('/contato')
    }
  }
}
</script>

<style lang="sass" scoped>
.beyond-text,.beyond-info
  color: #F7F7F7

.box-anchor
  text-decoration: none
  color: #F7F7F7
</style>
